module.exports = __webpack_public_path__ + "img/269-3.0ac284cb.png";